import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ProductListClearItem from '../clear_item';
import ProductListDropdownItem from '../dropdown_item';
import { SVGs } from '../../../common/fa_icons';
import { colorClassName } from '../../../../utils/shopping';
import classNames from 'classnames';
import {map, find, noop} from 'lodash';

export class ProductListDesktopFilter extends Component {
  state = { showFilters: false };

  toggleFilterVisibility = () => {
    //close the filter & sort drop-down if it is open
    if (!this.props.filterSortHidden) {
      this.props.toggleFilterAndSort();
    }

    this.setState({
      showFilters: !this.state.showFilters
    });
  };

  handleClick = (event) => {
    this.props.handleFilter(event) || noop;
    this.toggleFilterVisibility();
  };

  render() {
    const { dropdownItems, handleFilter, label } = this.props;
    const { showFilters } = this.state;

    const filter = Number(this.props.filter);
    const selectedItem = find(this.props.dropdownItems, { id: filter });

    let clearIcon;
    if (selectedItem) {
      clearIcon = (
        <span className="fa fa-times"
          onClick={handleFilter}
          data-label={label}
          dangerouslySetInnerHTML={{ __html: SVGs.times }}
        />
      );
    }

    let clearListItem;
    if (selectedItem) {
      clearListItem = (
        <ProductListClearItem
          handleClick={this.handleClick}
          label={label}
        />
      );
    }

    return (
      <div tabIndex="0" className={`desktop-filter ${label}-select`} onClick={this.toggleFilterVisibility} onKeyPress={this.toggleFilterVisibility}>
        <span dangerouslySetInnerHTML={{ __html: label }} />
        <span className="dropdown">
          {
            selectedItem &&
              <span
                className={classNames(
                  'label',
                  colorClassName(selectedItem.name, label)
                )}
                dangerouslySetInnerHTML={{ __html: selectedItem.name }}
              />
          }
          {clearIcon}
          <span className="fa fa-chevron-down"
            dangerouslySetInnerHTML={{ __html: SVGs['chevron-down'] }}
          />
          <ul className={classNames({ 'active': showFilters })}>
            {
              map(dropdownItems, ({ id, name, path }) => (
                <ProductListDropdownItem key={id}
                  path={path}
                  handleClick={this.handleClick}
                  id={id}
                  label={label}
                  name={name}
                  shouldBeSelected={id === filter}
                />
              ))
            }
            {clearListItem}
          </ul>
        </span>
      </div>
    );
  }

}

ProductListDesktopFilter.propTypes = {
  dropdownItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.number
    }).isRequired
  ),
  filter: PropTypes.string,
  handleFilter: PropTypes.func,
  label: PropTypes.string,
  toggleFilterVisibility: PropTypes.func,
  showFilters: PropTypes.bool,
  filterSortHidden: PropTypes.bool,
  toggleFilterAndSort: PropTypes.func
};

export default ProductListDesktopFilter;
